import { OrgHealthDashboard } from "@/components/dashboard/OrgHealthDashboard";

export function OrgHealthPage() {
  return <OrgHealthDashboard />;
}
